export default __webpack_public_path__ + "static/media/event.6b28d79a.png";